import { ReactNode } from 'react';

import { VerticalTabsStyled } from './styles';

type Props = {
  activeKey: string;
  activeTabColor?: string;
  items: Array<TabsPaneType>;

  onChange?: (key: string) => void;
};

export type TabsPaneType = {
  key: string;
  label: ReactNode;
};

const VerticalTabs = ({
  activeKey,
  items,

  activeTabColor = 'red',

  onChange,
}: Props) => {
  return (
    <VerticalTabsStyled $activeTabColor={activeTabColor}>
      <div className="vertical-tabs-label-container">
        {items.map((item) => (
          <div
            key={item.key}
            className={`vertical-tab  ${
              item.key === activeKey ? 'active' : ''
            }`}
            onClick={() => onChange && onChange(item.key)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </VerticalTabsStyled>
  );
};

export default VerticalTabs;
